import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { ArrowDownRight } from "lucide-react";
import { EASE } from "@/components/Reveal";

const HeroArt = ({ reduce }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", reduce ? "0%" : "18%"]);
  const rotate = useTransform(scrollYProgress, [0, 1], [0, reduce ? 0 : 6]);
  return (
    <div ref={ref} className="pointer-events-none absolute inset-0 flex items-center justify-center px-6 pb-24 pt-16 md:justify-end md:px-[7vw] md:py-14">
      <motion.img
        src="/img/skull-art-v2.webp"
        alt="Sviin skull and crossbones artwork"
        fetchpriority="high"
        style={{ y, rotate }}
        initial={reduce ? false : { opacity: 0, scale: 0.9, rotate: -6 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ duration: 1.6, ease: EASE, delay: 0.2 }}
        className="h-auto max-h-full w-full max-w-[520px] object-contain drop-shadow-[0_30px_40px_rgba(17,17,17,0.12)] md:w-auto md:max-w-none"
      />
    </div>
  );
};

export const Hero = () => {
  const reduce = useReducedMotion();
  return (
    <section data-testid="hero-section" className="relative h-[calc(100svh-100px)] min-h-[560px] overflow-hidden md:h-[calc(100svh-108px)]">
      <HeroArt reduce={reduce} />
      <div className="relative flex h-full flex-col justify-between px-4 pb-8 pt-6 md:px-8 md:pb-12 md:pt-10">
        <motion.div className="label flex gap-6" initial={reduce ? false : { opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3, duration: 0.8 }}>
          <span>SS—26</span>
          <span className="text-[#111111]/60">Drop 01 / Now live</span>
        </motion.div>
        <motion.div initial={reduce ? false : { opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.8, ease: EASE }}>
          <a
            href="#latest-drop"
            data-testid="hero-shop-drop-button"
            className="label group relative inline-flex h-14 items-center gap-3 overflow-hidden bg-[#111111] px-7 text-[#F4F2EE]"
          >
            <span className="absolute inset-0 origin-bottom scale-y-0 bg-[#E2541B] transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-y-100" />
            <span className="relative">Shop the drop</span>
            <ArrowDownRight size={16} className="relative transition-transform duration-500 group-hover:rotate-[-45deg]" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
